import {
  Card,
  CardContent,
  CardHeader,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";

export function ChartCardSkeleton() {
  return (
    <Card>
      <CardHeader>
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-4 w-24" />
      </CardHeader>
      <CardContent>
        <div className="relative h-64">
          {/* Y-axis area */}
          <div className="absolute top-0 left-0 flex h-full flex-col justify-between py-5">
            <Skeleton className="h-3 w-8" />
            <Skeleton className="h-3 w-8" />
            <Skeleton className="h-3 w-8" />
            <Skeleton className="h-3 w-8" />
          </div>

          {/* Main chart area */}
          <div className="ml-12 flex h-full flex-col">
            <div className="flex-1 py-5">
              <Skeleton className="h-full w-full" />
            </div>

            {/* X-axis area */}
            <div className="flex justify-around pt-2">
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-3 w-8" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
